/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { logoUseTypeIdGet } from '../fn/logo-use-type/logo-use-type-id-get';
import { LogoUseTypeIdGet$Params } from '../fn/logo-use-type/logo-use-type-id-get';
import { LogoUseTypeModel } from '../models/logo-use-type-model';
import { LogoUseTypeModelSearchResultModel } from '../models/logo-use-type-model-search-result-model';
import { logoUseTypePost } from '../fn/logo-use-type/logo-use-type-post';
import { LogoUseTypePost$Params } from '../fn/logo-use-type/logo-use-type-post';
import { logoUseTypeSearchLogoUseTypePost } from '../fn/logo-use-type/logo-use-type-search-logo-use-type-post';
import { LogoUseTypeSearchLogoUseTypePost$Params } from '../fn/logo-use-type/logo-use-type-search-logo-use-type-post';

@Injectable({ providedIn: 'root' })
export class MDILogoUseTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `logoUseTypeSearchLogoUseTypePost()` */
  static readonly LogoUseTypeSearchLogoUseTypePostPath = '/LogoUseType/SearchLogoUseType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logoUseTypeSearchLogoUseTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  logoUseTypeSearchLogoUseTypePost$Response(params?: LogoUseTypeSearchLogoUseTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LogoUseTypeModelSearchResultModel>> {
    return logoUseTypeSearchLogoUseTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logoUseTypeSearchLogoUseTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  logoUseTypeSearchLogoUseTypePost(params?: LogoUseTypeSearchLogoUseTypePost$Params, context?: HttpContext): Observable<LogoUseTypeModelSearchResultModel> {
    return this.logoUseTypeSearchLogoUseTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<LogoUseTypeModelSearchResultModel>): LogoUseTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `logoUseTypeIdGet()` */
  static readonly LogoUseTypeIdGetPath = '/LogoUseType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logoUseTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  logoUseTypeIdGet$Response(params: LogoUseTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LogoUseTypeModel>> {
    return logoUseTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logoUseTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logoUseTypeIdGet(params: LogoUseTypeIdGet$Params, context?: HttpContext): Observable<LogoUseTypeModel> {
    return this.logoUseTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<LogoUseTypeModel>): LogoUseTypeModel => r.body)
    );
  }

  /** Path part for operation `logoUseTypePost()` */
  static readonly LogoUseTypePostPath = '/LogoUseType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logoUseTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  logoUseTypePost$Response(params?: LogoUseTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return logoUseTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logoUseTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  logoUseTypePost(params?: LogoUseTypePost$Params, context?: HttpContext): Observable<string> {
    return this.logoUseTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
